function getCookieValue(name) {
  if (typeof document !== 'undefined') {
    var matches = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')
    return matches ? matches.pop() : ''
  } else {
    return 0
  }
}

module.exports = getCookieValue
